import {
  getTravelQuotation,
  setMessageVisibility,
  getQuestion,
  getFormValue,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum, ModelPathEnum } from 'app/shared/enums';
import {
  getAgeFromPesel,
  getBirthdayString,
  isPeselValid,
} from 'app/services/pesel.service';
import { getMessageKeyWithSuffix } from 'app/services/validation.service';
import { TravelQuotationService } from 'app/services/travelQuotation.service';
import { validateTravelPeselUniqueness } from 'app/services/businessFunctions/helpers/validateTravelPeselUniqueness';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';

const formName = FormsEnum.TravelCheckoutForm;

function validatePesel(
  travelerPeselQuestionKey: FieldsEnum,
  travelerAgeModelPath: ModelPathEnum,
  travelerBirthDateModelPath: ModelPathEnum
) {
  const pesel = getFormValue(travelerPeselQuestionKey, formName);
  const quotation = getTravelQuotation();
  const { modelPath: peselModelPath } = getQuestion(
    travelerPeselQuestionKey,
    formName
  );

  if (!pesel && pesel !== '') {
    return;
  }

  const isValid = isPeselValid(pesel);
  const isUnique = validateTravelPeselUniqueness(travelerPeselQuestionKey);

  setMessageVisibility({
    formName,
    key: getMessageKeyWithSuffix(
      travelerPeselQuestionKey,
      'notUnique_pesel_short'
    ),
    visible: !isUnique,
  });

  if ((isValid && isUnique) || pesel === '') {
    TravelQuotationService.update(quotation.id, peselModelPath, pesel);

    if (pesel !== '') {
      const birthDate = getBirthdayString(pesel);
      let ageFromPesel = getAgeFromPesel(pesel);

      if (ageFromPesel < 18) {
        ageFromPesel = 0;
      }
      if (ageFromPesel >= 70) {
        ageFromPesel = 70;
      }

      TravelQuotationService.update(
        quotation.id,
        travelerAgeModelPath,
        ageFromPesel
      );

      if (birthDate) {
        TravelQuotationService.update(
          quotation.id,
          travelerBirthDateModelPath,
          birthDate
        );
      }
    }
  }
}

export const travelers = {
  checkoutTraveler1PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler1Pesel,
      ModelPathEnum.TravelTraveler1Age,
      ModelPathEnum.TravelTraveler1BirthDate
    );
  },
  checkoutTraveler1HomeAddressZipCodeChange(initialRun: boolean) {
    zipCodeChange(
      initialRun,
      FieldsEnum.TravelCheckoutTraveler1HomeAddressZipCode,
      formName
    );
  },
  checkoutTraveler2PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler2Pesel,
      ModelPathEnum.TravelTraveler2Age,
      ModelPathEnum.TravelTraveler2BirthDate
    );
  },
  checkoutTraveler2HomeAddressZipCodeChange(initialRun: boolean) {
    zipCodeChange(
      initialRun,
      FieldsEnum.TravelCheckoutTraveler2HomeAddressZipCode,
      formName
    );
  },
  checkoutTraveler3PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler3Pesel,
      ModelPathEnum.TravelTraveler3Age,
      ModelPathEnum.TravelTraveler3BirthDate
    );
  },
  checkoutTraveler4PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler4Pesel,
      ModelPathEnum.TravelTraveler4Age,
      ModelPathEnum.TravelTraveler4BirthDate
    );
  },
  checkoutTraveler5PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler5Pesel,
      ModelPathEnum.TravelTraveler5Age,
      ModelPathEnum.TravelTraveler5BirthDate
    );
  },
  checkoutTraveler6PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler6Pesel,
      ModelPathEnum.TravelTraveler6Age,
      ModelPathEnum.TravelTraveler6BirthDate
    );
  },
  checkoutTraveler7PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler7Pesel,
      ModelPathEnum.TravelTraveler7Age,
      ModelPathEnum.TravelTraveler7BirthDate
    );
  },
  checkoutTraveler8PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler8Pesel,
      ModelPathEnum.TravelTraveler8Age,
      ModelPathEnum.TravelTraveler8BirthDate
    );
  },
  checkoutTraveler9PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler9Pesel,
      ModelPathEnum.TravelTraveler9Age,
      ModelPathEnum.TravelTraveler9BirthDate
    );
  },
  checkoutTraveler10PeselChange() {
    validatePesel(
      FieldsEnum.TravelCheckoutTraveler10Pesel,
      ModelPathEnum.TravelTraveler10Age,
      ModelPathEnum.TravelTraveler10BirthDate
    );
  },
};
